// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1w2lZ","info":"PatientInfo_info__1wfqK"};